// extracted by mini-css-extract-plugin
module.exports = {"switch":"ob_vC80tC","disabled":"ob_jUzAPI","slider":"ob_VCePjT","slider_active":"ob_r4I601","slider_active_left":"ob_UmxZq1","slider_active_right":"ob_QQCp7n"};